import { UseFormReturn } from "react-hook-form";

import { ICustomer } from "./customer.interface";
import { TAny, TGeo } from "./globals";
import { ILoadType } from "./loadtype.interface";
import { IProject } from "./project.interface";
import { IVehicle } from "./vehicle.interface";

export enum RecoveryPathway {
  "Recycle" = "RECYCLE",
  "Energy Conversion" = "ENERGYCONVERSION",
  "Reuse" = "REUSE",
  "Landfill" = "LANDFILL",
}

export interface IWasteType {
  id: string;
  createdAt: string;
  updatedAt: string;
  name?: string;
  recoveryPathway?: RecoveryPathway;
  recyclingPercentage?: number;
  workspaceId?: string;
}

export interface WasteFormat {
  headerImage: string | null;
  headerOpacity: number;
  headerActive: boolean;
  watermarkImage: string | null;
  watermarkOpacity: number;
  watermarkScale: number;
  watermarkActive: boolean;
  footerImage: string | null;
  footerOpacity: number;
  footerActive: boolean;
  workspaceId?: string;
}

export type formType = UseFormReturn<
  {
    headerOpacity: number;
    headerActive: boolean;
    footerOpacity: number;
    footerActive: boolean;
    watermarkOpacity: number;
    watermarkActive: boolean;
    watermarkScale: number;
    headerImage?: TAny;
    footerImage?: TAny;
    watermarkImage?: TAny;
  },
  TAny,
  undefined
>;

export interface IDocument {
  id: string;
  name: string;
  url?: string;
  size: number;
  uploaderId?: string;
  workspaceId?: string;
  createdAt: string;
  uploader?: {
    firstName: string;
    lastName: string;
  };
}
export interface MixedWasteEntity {
  wasteName: string;
  percentage: number;
  wasteTypeId: string;
}
export interface OtherWasteEntity {
  wasteName: string;
  wasteTypeId: string;
}
export interface LoadType {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  image: string;
  tareWeight: number;
  workspaceId: string;
}
export interface WasteType {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  recoveryPathway: string;
  recyclingPercentage: number;
  workspaceId: string;
}

export interface BreakDownData {
  mixedWaste?: MixedWasteEntity[] | null;
  otherWaste?: OtherWasteEntity[] | null;
}

export interface WeighScaleTicketItem {
  id: string;
  loadTypeQuantity: number;
  wasteTypeWeight: number;
  breakDownData: BreakDownData;
  loadTypeId: string;
  wasteTypeId: string;
  weighScaleTicketId: string;
  loadType: LoadType;
  wasteType: WasteType;
}

export interface TGetWeighScale {
  id: string;
  isFromTab: boolean;
  ticketNumber: number;
  isArchived: boolean;
  workspaceID: string;
  projectId: string;
  customerId: string;
  dayReportID: string;
  project: IProject;
  customer: ICustomer & { workspaceID: string };
  date?: string | Date;
  totalWeight: number;
  weighScaleTicketItems: WeighScaleTicketItem[];
}

export interface WeighBridgeItemsEntity {
  id: string;
  createdAt: string;
  updatedAt: string;
  weighBridgeDetailsId: string;
  loadTypeId?: string | null;
  wasteTypeId: string;
  quantity?: number | null;
  loadType: ILoadType | null;
  wasteType: IWasteType | null;
}
export interface WeighBridgeDetailsEntity {
  id: string;
  createdAt: string;
  updatedAt: string;
  weighBridgeTicketId: string;
  orderNumber?: string | null;
  customerId?: string | null;
  projectId?: string | null;
  project?: IProject | null;
  customer?: ICustomer | null;
  weighBridgeItems?: WeighBridgeItemsEntity[] | null;
}
export interface TWeighBridge {
  id: string;
  createdAt: string;
  updatedAt: string;
  vehiclesId: string;
  vehicle: IVehicle;
  ticketNumber: number;
  grossWeight: number;
  customerId: string;
  workspaceId: string;
  tareWeight: number;
  notes: string;
  ticketType: string;
  isDraft: boolean;
  customer: ICustomer;
  WeighBridgeDetails?: WeighBridgeDetailsEntity[] | null;
}

export interface Project {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  status: string;
  startDate: Date;
  address: TGeo & { radius: number; postalCode: string };
  radius: number;
  projectNumber: string;
  referenceNumber: string;
  budgetHours: number;
  isGreenStarProject: boolean;
  customerID: string;
  userAccessListID: null;
}
